import React from "react";
import CRUDDetailPage from "../../../../shared/components/crud/CRUDDetailPage";
import { vaccinationPlanConfig } from "../config/vaccinationPlanConfig";
import { PlanService } from "../../../../shared/services/planService";

/**
 * StockManagementDetail - URL-based detail page for Stock Management
 * Handles view, edit, and add modes with ID from URL params
 */
export default function VaccinationPlanDetail() {
  console.log("🚀 ~ VaccinationPlanDetail ~ vaccinationPlanConfig:", vaccinationPlanConfig);
  return <CRUDDetailPage config={vaccinationPlanConfig} service={PlanService} />;
}
